module.exports = __webpack_public_path__ + "static/media/play-now-thadingyut-2025-theme.93468c34.png";